import "styles/floatInput.less";
import {
    ChangeEvent,
    useMemo,
} from "react";

import { Input } from "antd";
import checkMark from "assets/images/checkmark.svg";
import warning from "assets/images/warning.svg";

import SuffixIcon from "../Suffix/Suffix";

interface FloatInputProps {
    required: boolean;
    value?: string;
    placeholder?: string;
    type?: string;
    error?: string;
    warning?: string;
    dataTestId?: string;
    index?: number;
    onChange?: (_event: ChangeEvent<HTMLInputElement>) => void;
    icon?: string
    handleKeyDown?: (_event: any) => void;
    showPassword?: boolean;
    suffix?: string;
}

const FloatInput = ({
    required,
    value,
    placeholder,
    type,
    error,
    onChange,
    dataTestId,
    index,
    handleKeyDown,
    suffix,
}: FloatInputProps) => {
    const hasError = useMemo(() => {
        return !!error;
    }, [error]);

    const inputStatus = hasError ? "error" : undefined;

    return (
        <Input
            required={required}
            data-testid={dataTestId}
            size="large"
            onChange={onChange}
            type={type}
            value={value}
            placeholder={placeholder}
            autoFocus={index === 0}
            onKeyDown={handleKeyDown}
            status={inputStatus}
            suffix={
                <SuffixIcon
                    hasError={hasError}
                    hasValue={!!value}
                    suffixSrc={suffix}
                    checkmarkSrc={checkMark}
                    warningSrc={warning}
                />
            }

        />
    );
};

export default FloatInput;
